import React from "react";
import { AiOutlineUser } from "react-icons/ai";

const NewUsers = ({ users }) => {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <h3 className="flex items-center gap-2 text-lg font-bold text-slate-950">
            <AiOutlineUser className="text-sky-600" />
            New Users
          </h3>
          <p className="text-sm text-slate-500">Latest registered learners and subscription state</p>
        </div>
        <button className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">
          View all
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[860px] text-left text-sm">
          <thead>
            <tr className="border-y border-slate-100 bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Email</th>
              <th className="px-4 py-3 font-semibold">Joined</th>
              <th className="px-4 py-3 font-semibold">Plan</th>
              <th className="px-4 py-3 font-semibold">Last Login</th>
              <th className="px-4 py-3 font-semibold">Payment</th>
              <th className="px-4 py-3 font-semibold">Subscription</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {users.map((user) => (
              <tr key={user.email} className="text-slate-700 transition hover:bg-slate-50">
                <td className="px-4 py-4">
                  <div className="font-semibold text-slate-950">{user.name}</div>
                </td>
                <td className="px-4 py-4 text-slate-500">{user.email}</td>
                <td className="px-4 py-4">{user.joinedDate}</td>
                <td className="px-4 py-4">
                  <span className="rounded-full bg-sky-50 px-2.5 py-1 text-xs font-semibold text-sky-700">
                    {user.plan}
                  </span>
                </td>
                <td className="px-4 py-4">{user.lastLogin}</td>
                <td className="px-4 py-4">{user.paymentMethod}</td>
                <td className="px-4 py-4">
                  <span
                    className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
                      user.subscriptionStatus === "Active"
                        ? "bg-emerald-50 text-emerald-700"
                        : "bg-rose-50 text-rose-700"
                    }`}
                  >
                    {user.subscriptionStatus}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewUsers;
